export const paddy = (num, padlen, padchar): string => {
  const PAD_CHAR = padchar ?? '0';
  const PAD = new Array(1 + padlen).join(PAD_CHAR);
  return (PAD + num).slice(-PAD.length);
}
